const validShopOrderItem = item => {
  const unitPrice = item?.unitPrice;
  return (
    typeof item?.listingId === 'string' &&
    item.listingId.length > 0 &&
    typeof item?.title === 'string' &&
    item.title.length > 0 &&
    Number.isInteger(item?.quantity) &&
    item.quantity > 0 &&
    Number.isInteger(unitPrice?.amount) &&
    unitPrice.amount > 0 &&
    typeof unitPrice?.currency === 'string' &&
    unitPrice.currency.length > 0
  );
};

/**
 * Returns immutable item snapshots for a grouped Shelfy shop order.
 * Invalid or single-item manifests fall back to the standard transaction display.
 */
export const getGroupedShopOrderItems = protectedData => {
  const manifest = protectedData?.shelfyShopOrder;
  const items = manifest?.items;
  const hasExpectedCount =
    Array.isArray(items) &&
    Number.isInteger(manifest?.itemCount) &&
    manifest.itemCount === items.length;

  return hasExpectedCount && items.length > 1 && items.every(validShopOrderItem) ? items : null;
};

/**
 * Returns the total purchased quantity for a valid grouped Shelfy shop order.
 */
export const getGroupedShopOrderItemCount = protectedData => {
  const items = getGroupedShopOrderItems(protectedData);
  return items ? items.reduce((count, item) => count + item.quantity, 0) : 0;
};
